module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMORvN1gns6dxOHn8Pjz+PvO4fD///+20umFtdpUl8tsptJHj8d4rdba6fR2gybFAAAAB3RSTlMAYL8AIM/vi50ITwAAALxJREFUeF7t2EkOwyAMhlHGmDnz/a9aUJRlLFqsLlp/B3gLJCT4RUsqGEhJXRNaGwuDWdMgM8Fwk6mQBYKsFhJIkkLRQEoAUb8EMeS3h/xbkD/LY6fvh/ZUkNLeDbmC5rqhjEP5+9CMQ3M3tOHQ1g3BgjkL9EOwunAVbyCGK7d+dkUycsL/CDHEEEMMMcQQQwy5G3KD0P12T/sgBD42J3qC39ERwsEfPzSGyEYWstmHaogim8Yox7oaxXz4AstLnndbATekAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1f9.png
// module id = 614
// module chunks = 0